import React, { useId } from "react"
import { cn } from "../utils"
import { VisuallyHidden } from "../visually-hidden"
import { PageSecondaryHeaderCenterContent } from "./page-secondary-header-center-content"
import { PageSecondaryHeaderOverflowScroll } from "./page-secondary-header-overflow-scroll"

// =============================================================================
// Props
// =============================================================================

export type PageSecondaryHeaderStepsProps = {
  /** Page header steps */
  children?: React.ReactNode
  className?: string
}

// =============================================================================
// Styles
// =============================================================================

const pageSecondaryHeaderStepsStyles = ["flex items-center w-max"]

// =============================================================================
// Component
// =============================================================================

/**
 * Secondary page header steps.
 *
 * Displays the current step in a workflow.
 */
export function PageSecondaryHeaderSteps({
  children,
  className
}: PageSecondaryHeaderStepsProps) {
  const accessibleNameId = useId()

  return (
    <PageSecondaryHeaderCenterContent>
      <PageSecondaryHeaderOverflowScroll
        render={
          <nav aria-labelledby={accessibleNameId} data-slot="secondary-steps" />
        }
      >
        <VisuallyHidden id={accessibleNameId}>Steps</VisuallyHidden>
        <ol className={cn(pageSecondaryHeaderStepsStyles, className)}>
          {children}
        </ol>
      </PageSecondaryHeaderOverflowScroll>
    </PageSecondaryHeaderCenterContent>
  )
}
